import { useLanguage } from "@/lib/i18n";
import { blogContent } from "./content";

export function ProblemSection() {
  const { language } = useLanguage();
  const c = blogContent[language].problem;

  return (
    <section className="mx-auto max-w-[680px] px-4 sm:px-6 pb-12">
      <div className="space-y-10">
        {c.problems.map((problem, i) => (
          <article key={i}>
            <h2 className="font-['Source_Serif_4'] text-[1.5rem] sm:text-[1.75rem] leading-tight font-semibold text-foreground mt-4 mb-5">
              <span className="text-primary mr-2">{i + 1}.</span>
              {problem.title}
            </h2>
            {problem.paragraphs.map((para, j) => (
              <p
                key={j}
                className="font-['Source_Serif_4'] text-[1.0625rem] sm:text-lg leading-[1.75] text-foreground/85 mb-4 last:mb-0"
              >
                {para}
              </p>
            ))}
          </article>
        ))}
      </div>
    </section>
  );
}
